import { gql } from '@apollo/client';

export const SET_CREDENTIALS_MEMPHIS = gql`
  mutation SetMemphisCredentials($credentials: MemphisCredentialsInput!) {
    setMemphisCredentials(credentials: $credentials) {
      ... on SetMemphisCredentialsSuccess {
        code
        credentials {
          username
          password
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
